export const REMEMBER_ME_COOKIE_KEY = "__rememberMe";
